import { createSystem, defaultConfig } from "@chakra-ui/react";

import { baseTheme, generateBaseTokensCss } from "./baseTokens";

// Chakra UI theme extensions
export const system = createSystem(defaultConfig, {
  globalCss: {
    body: {
      bg: "var(--color-bg, #f5f5f5)",
      color: "var(--color-text, #1a1a1a)",
    },
  },

  theme: {
    tokens: {
      fonts: {
        heading: {
          value: "var(--font-body)",
        },
        body: {
          value: "var(--font-body)",
        },
      },

      fontWeights: {
        normal: {
          value: 400,
        },
        medium: {
          value: 500,
        },
      },
    },
  },
});

export const theme = system;
export { baseTheme };

// Create and inject the CSS variables (browser-only; skipped during SSR where
// `document` is undefined). Also skipped when the SSR HTML already injected
// these via vike-ssr-base-tokens — avoids a repaint flash from appending a
// redundant style tag during hydration.
if (
  typeof document !== "undefined" &&
  !document.querySelector("style[data-source='vike-ssr-base-tokens']")
) {
  const styleSheet = document.createElement("style");
  styleSheet.textContent = generateBaseTokensCss(baseTheme);
  document.head.appendChild(styleSheet);
}
